import { sel, selAll } from '../utils'
import { VidstackPlayer, VidstackPlayerLayout } from 'vidstack/global/player'

export default function VideoMod() {
  // console.log('Init video modals')
  // slider class
  const parent = 'data-modal-parent'
  const modal$a = selAll(`[${parent}]`)
  // console.log('modal$a', modal$a)
  if (modal$a.length === 0) return //console.log('No link modals found')

  const modalWrapper = document.createElement('div')
  modalWrapper.classList.add('video-modals')
  let lastModal$
  modal$a.forEach((modal$, i) => {
    // select a sibling with the attribute [mod-link], of none traverse up the DOM tree
    const link$ = modal$.parentNode.sel('[data-modal-link]') || modal$.closest('[data-modal-link]')
    if (!link$) return console.log('No link found for modal', modal$)
    link$.setAttribute('data-modal-link', `video-${i}`)

    modal$.setAttribute('data-modal-linked', `video-${i}`)
    // wrapper$.appendChild(modal$)
    modalWrapper.appendChild(modal$)

    async function videoModal() {
      const _player = modal$.sel('.custom_player')
      // console.log(_player.getAttribute('src'))
      const src = _player.getAttribute('data-src') || 'youtube/4UgnVc7kRxE'
      const player = await VidstackPlayer.create({
        target: _player,
        src: src,
        // poster:
        // 'https://cdn.prod.website-files.com/655b9a852f3d2a5de3c90048/6826898440714274aa9fd120_67575b133690ca3c5bb9254a_test_img1_q85-gigapixel-low%20resolution%20v2-4x%20copy.webp',
        crossOrigin: true,
        playsInline: true,
        viewType: 'video',
        load: 'idle',
        layout: new VidstackPlayerLayout(),
      })
      modal$.player = player
    }
    videoModal()

    function modalInit(modal$) {
      if (modal$.tl) return

      const modalMod$ = modal$.sel('.mod')
      const modalX$ = modal$.sel('.mod__x-w')
      const modalBg$ = modal$.sel('.mod-bg')

      gsap.set(modal$, { display: 'flex', autoAlpha: 0 })

      modal$.tl = gsap
        .timeline({ defaults: { duration: 1, ease: 'power4.inOut' }, paused: true })
        //
        .to(modal$, { autoAlpha: 1 })
        .from(modalMod$, { y: 50 }, 0)
      ;[modalX$, modalBg$].forEach((el) => {
        el.addEventListener('click', () => {
          console.log('close modal')
          modal$.tl.reverse()
          modal$.player.pause()
          slider$.splide?.Components.Autoplay.play()
          // modTl.reverse().then(() => {
          //   // modal$.style.display = 'none'
          // })
        })
      })
      lastModal$ = modal$
    }
    modalInit(modal$)
  })
  const parentClass = lastModal$.getAttribute(parent)
  const parent$ = sel(`.${parentClass}`) || document.body
  const _slider = lastModal$.getAttribute('data-modal-parent')
  const slider$ = sel(`.${_slider}`)
  parent$.addEventListener('click', (e) => {
    e.preventDefault()
    e.stopPropagation()
    const target = e.target.closest('[data-modal-link]')
    if (!target) return
    const modalAttr = target.getAttribute('data-modal-link')
    const modal$ = sel(`[data-modal-linked="${modalAttr}"]`)

    console.log('open modal', parent$, target, modalAttr)
    modal$.tl.play()
    modal$.player.play()
    slider$.splide?.Components.Autoplay.pause()
    // console.dir(slider$)
  })

  document.body.appendChild(modalWrapper)
}
